import { Box, Typography, Button, Select, MenuItem, InputLabel, Menu, TextField, TableRow, TableCell } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import { ReactComponent as Download } from "../../../../../assets/AccountingModule/bill_download.svg";
import { ReactComponent as Send } from "../../../../../assets/AccountingModule/bill_send.svg";
import { ReactComponent as DownloadBlue } from "../../../../../assets/invoice/blueDownload.svg";
import Modal from "../../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import dropDownIcon from '../../../../../assets/AccountingModule/dropdown_black.svg'
import threeDotsIcon from '../../../../../assets/AccountingModule/threeDot.svg'
import editIcon from '../../../../../assets/AccountingModule/edit2.svg'
import deleteIcon from '../../../../../assets/AccountingModule/delete.svg'
import { formatToDDMMYYYY } from "../../../../../utils/DateFormat";

const InvoiceView = ({ handleDownload, getViewInvoice, handleDownloadReceipt, invoiceData, handleSentReceipt, getReceiptView, cashReceipt, sentInvoice, data, item, paidInvoice, handleShowPdf, flag, updatePayment, handleDeleteTransaction, handleExportPayslip, id, handlePrintPayslip, isPayslipAccessDisabled }) => {
  const [billHtml, setBillHtml] = useState("");
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [type, setType] = useState("");
  const [bank, setBank] = useState("");
  const [bankId, setBankId] = useState("");
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [invoicePayDate, setInvoicePayDate] = useState(dayjs());
  const [amount, setAmount] = useState("");
  const [reference, setReference] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentPaymentId, setCurrentPaymentId] = useState(null);
  const [menuPayment, setMenuPayment] = useState(null);
  const sortedPayments = [...(invoiceData?.payments || [])].sort((a, b) =>
    new Date(b.date) - new Date(a.date)
  );

  useEffect(() => {
    const fetchBill = async () => {
      if (flag === "paylist") {
        if (isPayslipAccessDisabled) return;
        const result = await handleShowPdf();
        setBillHtml(result.__html);
      } else if (cashReceipt) {
        const result = await getReceiptView();
        setBillHtml(result.__html)
      } else {
        const result = await getViewInvoice();
        setBillHtml(result.__html);
      }
    };
    fetchBill();
  }, [flag, handleShowPdf, isPayslipAccessDisabled]);

  const handleEditPayment = (payment) => {
    setIsEditing(true);
    setCurrentPaymentId(payment.transactionId);
    setInvoicePayDate(dayjs(payment.date));
    setType(payment.method);
    setReference(payment.reference || "");

    setAmount(payment.amount.toString());

    if (payment.method === "Bank" && payment.account) {
      setBankId(payment.account);
      const bankInfo = data.find(b => b._id === payment.account);
      if (bankInfo) {
        setBank(bankInfo._id);
      }
    } else {
      setBank("");
      setBankId("");
    }

    setOpen(true);
    setAnchorEl(null);
  };

  const resetForm = () => {
    setIsEditing(false);
    setCurrentPaymentId(null);
    setInvoicePayDate(dayjs());
    setType("");
    setBank("");
    setBankId("");
    setAmount("");
    setReference("");
  };

  const handleCheck = () => {
    const numericAmount = parseFloat(amount);

    const payload = {
      date: invoicePayDate.toISOString(),
      type,
      amount: numericAmount,
      reference,
      ...(type === "Bank" && { bankId }),
      ...(type === "Cash" && { bankId: "" })
    };

    if (isEditing && currentPaymentId) {
      updatePayment({
        invoiceId: invoiceData._id,
        transactionId: currentPaymentId,
        payload
      });
    } else {
      paidInvoice(payload);
    }
    setOpen(false);
    resetForm();
  };

  const handleSendInvoice = () => {
    sentInvoice();
  };

  const deleteTransaction = async (invoiceId, transactionId) => {
    handleDeleteTransaction(invoiceId, transactionId);
  }

  return (
    <>
      {flag === "paylist" && (
        <style>{`
          @media print {
            body * { visibility: hidden; }
            .payslip-print-area, .payslip-print-area * { visibility: visible; }
            .payslip-print-area { position: absolute; left: 0; top: 0; width: 100%; }
            .payslip-actions-no-print { display: none !important; }
          }
        `}</style>
      )}
      <Box sx={style.mainGrid}>
        <Box sx={{ display: "flex", alignItems: "center" , justifyContent: "space-between", width: "100%"}}>
          <Typography variant="h5" sx={style.leaveHeading}>
            {flag === "paylist" ? "Payslip" : cashReceipt ? "Cash Receipt" : "Invoice Details"}
          </Typography>
          {!(flag === "paylist" && isPayslipAccessDisabled) && (
            <Box sx={{ display: "flex", gap: "8px", ml: "auto" }} className="payslip-actions-no-print">
              <Button
                sx={style.exportBtn}
                onClick={() => handleExportPayslip(id)}
              >
                <DownloadBlue />
                Export
              </Button>
              {flag === "paylist" && (
                <Button
                  sx={style.exportBtn}
                  onClick={handlePrintPayslip}
                >
                  Print
                </Button>
              )}
            </Box>
          )}
        </Box>
        {flag === "paylist" && isPayslipAccessDisabled && (
          <Typography sx={style.accessDisabledText}>
            Your payslip access has been disabled. Please contact your employer if you need a payslip.
          </Typography>
        )}
        {!cashReceipt && <Box sx={{ display: "flex" }}>
          {(item?.status === "Sent" || item?.status === "Partially Paid") && (
            <Button
              variant="contained"
              color="success"
              sx={style.paidButton}
              onClick={() => setOpen(true)}
            >
              {"Record Payment "}
            </Button>
          )}
          {flag !== "paylist" && (
            <Box sx={style.textGrid}>
              <Button
                variant="contained"
                color="success"
                sx={style.csvBtns}
                onClick={handleDownload}
              >
                <Download />
                {"Download"}
              </Button>

              {item?.status === "Draft" ? (
                <Button
                  variant="contained"
                  color="success"
                  sx={style.checkinBtns}
                  onClick={handleSendInvoice}
                >
                  <Send />
                  {"Send Invoice"}
                </Button>
              ) : (() => {
                let label = "Paid";
                let backgroundColor = "#2e7d32";
                let hoverColor = "#2e7d32";
                let textColor = "#fff";

                if ((item?.status === "Sent" || item?.status === "Partially Paid") && item?.dueDate) {
                  const now = new Date();
                  const dueDate = new Date(item.dueDate);
                  const diffTime = dueDate.getTime() - now.getTime();
                  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                  if (diffDays > 0) {
                    label = `Due in ${diffDays} day${diffDays > 1 ? "s" : ""}`;
                    backgroundColor = "#FFC107";
                    hoverColor = "#FFB300";
                    textColor = "#000";
                  } else if (diffDays < 0) {
                    label = `Overdue by ${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? "s" : ""}`;
                    backgroundColor = "#f44336";
                    hoverColor = "#d32f2f";
                    textColor = "#fff";
                  } else {
                    label = "Due today";
                    backgroundColor = "#FFC107";
                    hoverColor = "#FFB300";
                    textColor = "#000";
                  }
                }

                return (
                  <Button
                    variant="contained"
                    sx={{
                      ...style.checkinBtns,
                      backgroundColor,
                      color: textColor,
                      "&:hover": {
                        backgroundColor: hoverColor
                      }
                    }}
                  >
                    {label}
                  </Button>
                );
              })()}
            </Box>
          )}
        </Box>}
      </Box>
      <Box sx={{ ml: 2, display: "flex", justifyContent: "space-between", mt: 1 }}>
        {cashReceipt && <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="success"
            sx={style.csvBtns}
            onClick={handleDownloadReceipt}
          >
            <Download />
            {"Download"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={style.checkinBtns}
            onClick={() => handleSentReceipt()}
          >
            <Send />
            {"Send Receipt"}
          </Button>
        </Box>}

      </Box>

      {flag !== "paylist" && (
        <Box sx={style.paymentSection}>
          <Box sx={style.paymentHeader}>
            <Box sx={style.paymentTitleContainer}>
              <Typography sx={style.paymentTitle}>Payments Received</Typography>
              <Typography sx={style.paymentCount}>{sortedPayments?.length}</Typography>
            </Box>
            <Box>
              <button
                type="button"
                style={style.dropDownButton}
                aria-label="Open payment options"
                onClick={() => setIsTableVisible(prev => !prev)}
              >
                <img src={dropDownIcon} alt="Dropdown Icon" style={{
                  transform: isTableVisible ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"
                }} />
              </button>
            </Box>
          </Box>
          {isTableVisible && (
            <Box sx={{ overflowX: "auto" }}>
              <table>
                <thead style={{ background: "transparent !important", borderBottom: '1px solid #D9D9D9' }}>
                  <tr>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Date</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Payment</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Reference</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Payment Mode</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Amount</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedPayments.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography variant="h6">No Payment Recorded</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (sortedPayments.map((item, index) => (
                    <tr key={index}>
                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>{formatToDDMMYYYY(item?.date || "N/A")}</td>
                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>{sortedPayments.length - index || "N/A"}</td>
                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>{item?.reference || "N/A"}</td>
                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>{item?.method || "N/A"}</td>
                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>
                        {item?.amount !== undefined && item?.amount !== null
                          ? item.amount.toString().includes(".")
                            ? item.amount.toString().split(".")[0] + "." + item.amount.toString().split(".")[1].slice(0, 5)
                            : item.amount
                          : "N/A"}
                      </td>

                      <td style={{ ...style.tableCell, borderBottom: 'none' }}>
                        <Box>
                          <Button
                            variant="text"
                            sx={style.actionButton}
                            onClick={(event) => { setAnchorEl(event.currentTarget), setMenuPayment(item) }}
                          >
                            <img src={threeDotsIcon} alt="View" />
                          </Button>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => { setAnchorEl(null), setMenuPayment(null); }}
                            sx={style.dropdownMenu}
                          >
                            <MenuItem onClick={() => handleEditPayment(menuPayment)}>
                              <img src={editIcon} alt="Edit" style={{ marginRight: '8px' }} />
                              Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                deleteTransaction(invoiceData._id, menuPayment.transactionId);
                                setAnchorEl(null);
                                setMenuPayment(null);
                              }}>
                              <img src={deleteIcon} alt="Delete" style={{ marginRight: '8px' }} />
                              Delete
                            </MenuItem>
                          </Menu>
                        </Box>
                      </td>
                    </tr>
                  )))}
                </tbody>
              </table>
            </Box>
          )}
        </Box >
      )}

      {!(flag === "paylist" && isPayslipAccessDisabled) && (
        <Box sx={style.whiteSection} className="payslip-print-area">
          <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
        </Box>
      )}

      <Modal
        open={open}
        setOpen={(value) => {
          setOpen(value);
          if (!value) {
            resetForm();
          }
        }}
        btnText={isEditing ? "Update" : "Send"}
        disabled={!type || (type === "Bank" && !bank) || !amount || !reference}
        title={isEditing ? "Edit Payment" : "Record Payment"}
        handleCheck={handleCheck}
      >
        <Box>
          <Box sx={style.inputGrids}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel sx={style.label}>Payment Date</InputLabel>
              <DatePicker
                value={invoicePayDate}
                minDate={dayjs(item?.invoiceDate)}
                maxDate={dayjs()}
                onChange={(newValue) => { setInvoicePayDate(newValue) }}
                sx={style.dateInput}
                slotProps={{
                  field: {
                    readOnly: true
                  }
                }} />
            </LocalizationProvider>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Type</InputLabel>
            <Select
              value={type || ""}
              onChange={(e) => {
                setType(e.target.value);
                if (e.target.value !== "Bank") {
                  setBank("");
                }
              }}
              name="type"
              sx={style.hoursInput}
              displayEmpty
            >
              <MenuItem disabled value="">
                Select Type
              </MenuItem>

              <MenuItem sx={style.dropDownMenu} value="Cash">
                Cash
              </MenuItem>
              <MenuItem sx={style.dropDownMenu} value="Bank">
                Bank
              </MenuItem>
            </Select>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Bank</InputLabel>
            <Select
              value={bankId || ""}
              disabled={type !== "Bank"}
              name="bank"
              onChange={(e) => {
                setBankId(e.target.value);
                const selectedBank = data.find(b => b._id === e.target.value);
                setBank(selectedBank?._id || "");
              }}
              sx={style.hoursInput}
              displayEmpty
            >
              <MenuItem disabled value="">
                Select Type
              </MenuItem>
              {data?.map((bank) => (
                <MenuItem key={bank._id} value={bank._id}>
                  {`${bank?.bankName} - ${bank.accountNumber?.slice(-4)}`}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={{ ...style.labels }}>Reference</InputLabel>
            <TextField
              name="bankId"
              placeholder="Enter Reference"
              value={reference}
              sx={style.hoursInput}
              onChange={(e) => setReference(e && e.target ? e.target.value : "")}
            />
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Amount</InputLabel>
            <TextField
              value={amount}
              type="number"
              sx={style.hoursInput}
              onChange={(e) => setAmount(e && e.target ? e.target.value : "")}
              name="amount"
              placeholder="Enter Amount"
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default InvoiceView;